var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.084 25.949Q1 24.254 1 19.3q0-4.58 3.768-6.266-.04-3.551 2.458-6.174Q9.95 4 14 4q4.806 0 7.777 3.671l-1.554 1.258Q17.851 6 14 6q-3.193 0-5.326 2.24-2.138 2.245-1.877 5.377.064.773-.668 1.027Q3 15.733 3 19.3q0 3.513 3.716 4.751ZM25.387 10.578Q31 12.932 31 18.7q0 3.414-2.443 5.857T22.7 27H11.5v-2h11.2q2.586 0 4.443-1.857T29 18.7q0-4.438-4.387-6.278Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m1.293 29.293 28-28 1.414 1.414-28 28z"
})));
export default SvgCloudOff;